<template>
  <div class="report-item">
    <h3>{{report.title}}</h3>
    <component
      :is="getReportOption.component"
      class="report-item__content"
      :class="getReportOption.class"
      v-bind="getReportOption.props(report.content)"
    />
  </div>
</template>

<script>
import AdminReportTable from '@components/admin/AdminReports/AdminReportTable.vue'
import BaseLineChart from '@components/common/BaseLineChart.vue'
import BaseMapPolygons from '@components/common/BaseMapPolygons.vue'
import Heatmap from '@components/partials/Heatmap.vue'

const REPORT_TABLE = 'table'
const REPORT_CHART = 'chart'
const REPORT_HEATMAP = 'heatmap'
const REPORT_AREA = 'area'

export default {
  name: 'ReportItem',
  components: {
    AdminReportTable, BaseLineChart, BaseMapPolygons, Heatmap
  },
  props: {
    report: { type: Object, default: () => {} }
  },
  computed: {
    getReportOption() {
      return this.reportOptions[this.report.type]
    },
    reportOptions() {
      return {
        [REPORT_TABLE]: {
          component: 'AdminReportTable',
          props: content => this.getTableData(content),
          class: 'report-item__table'
        },
        [REPORT_CHART]: {
          component: 'BaseLineChart',
          props: content => this.getChartData(content)
        },
        [REPORT_AREA]: {
          component: 'BaseMapPolygons',
          props: content => this.getPolygonData(content)
        },
        [REPORT_HEATMAP]: {
          component: 'Heatmap',
          props: content => ({ initialPoints: content })
        }
      }
    }
  },

  methods: {
    getTableData(data) {
      return {
        data: data,
        columns: Object.keys(data[0] || {}).map(col => ({ label: col, value: col }))
      }
    },
    getChartData(data) {
      const series = []
      const categories = []

      data.forEach(({ X, ...y }) => {
        categories.push(X)
        Object.entries(y).forEach(([line, value]) => {
          const index = series.findIndex(s => s.name === line)
          if (index < 0) {
            series.push({ name: line, data: [value] })
          } else {
            series[index].data.push(value)
          }
        })
      })

      return { series, categories }
    },

    getPolygonData(data) {
      return {
        polygons: (data.features[0]?.geometry?.coordinates || []).map(paths => {
          return paths.map(path => ({ lat: path[1], lng: path[0]}))
        })
      }
    }
  }
}
</script>

<style>
.report-item__content {
  width: 100%;
  height: 300px;
}

@media print {
  .report-item__table {
    height: auto;
  }
}
</style>
